module.exports = __webpack_public_path__ + "img/zhaoxin.246c054a.jpg";